import styled from "styled-components";
import { Input, Typography, Form as AntdFormItem, DatePicker, Table, Row, Col } from "antd";
import PhoneInput from "react-phone-input-2";
import { LeftOutlined } from '@ant-design/icons';

const { Title } = Typography;

export const InputLabel = styled.label`
  display: block;
  text-align: left;
  text-decoration: none;
  font-size: 0.875rem;
  margin-bottom: 0.2rem;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

export const FormItem = styled(AntdFormItem.Item)`
  align-items: center;
  .ant-form-item-explain-error {
    text-align: left;
  }
`;

export const FormInput = styled(Input)`
  border-radius: 0.5rem;
  padding: 7px 11px;
`;
export const FormDatePicker = styled(DatePicker)`
  border-radius: 6px;
  padding: 7px 11px;
  width: 100% !important;
`;

export const StyledTitle = styled(Title)`
  margin-top: 0;
  margin-bottom: 20px;
`;

export const StyledPhoneInput = styled(PhoneInput)`
  .form-control {
    width: 100%;
    height: 40px;
  }
`;

export const ModalContent = styled.div`
  padding-top: 10px;
`;

export const ImageWrapper = styled.div`
  width: 92px;
  height: 92px;
  border: 1px solid #000;
`;

export const PrematchModalRow = styled.div`
  padding: 32px;
  border: 1px solid #000;

  @media (max-width: 500px) {
    width: 500px;
    overflow-x: scroll;
  }
`;

export const PrematchSubWrapper = styled(Row)`
  line-height: 40px;
  flex-wrap: nowrap;
`;

export const CustomCol = styled(Col)`
  padding: 0 16px;
  border: 1px solid #000;
  border-top: none;
  border-bottom: none;
  margin-left: 10px;
  margin-right: 10px;
`;

export const FirstCustomCol = styled(Col)`
  padding: 0 16px;
  border: 1px solid #000;
  border-top: none;
  border-bottom: none;
  margin-left: 10px;
  margin-right: 10px;
`;

export const LastCustomCol = styled(Col)`
  padding: 0 16px;
  padding-bottom: 8px;
  border: 1px solid #000;
  border-radius: 0px 0px 10px 10px;
  border-top: none;
  margin-left: 10px;
  margin-right: 10px;
`;

export const TitleCol = styled(Col)`
  font-size: 20px;
  font-weight: 600;
`;

export const TitleColLostItem = styled(Col)`
  font-size: 20px;
  font-weight: 600;
  padding: 0 16px;
  margin-left: 10px;
  margin-right: 10px;
  border: 1px solid #000;
  border-radius: 10px 10px 0px 0px;
  border-bottom: none;
`;
export const StyledTableWrapper = styled.div`
  border: 1px solid #c2c2c2;
  border-radius: 4px;
  border-bottom: none;

  .even-row {
    background-color: #f5f5f5;
  }

  .odd-row {
    background-color: #FFFFFF;
  }
`;


export const PreMatchStyledTable = styled(Table)`
  overflow-x: auto;

  .ant-table-cell {
    text-align: left;
  }
  .ant-table-thead > tr > th {
    background-color: #134076;
    padding: 10px 16px;
    font-weight: bold;
    text-align: left;
    border-right: none !important;
    color: #fff;
    border-bottom: none;
  }

  .ant-table-thead > tr > th::before {
    background-color: #134076 !important;
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #c2c2c2;
    border-right: 1px solid #c2c2c2;
    padding: 10px 16px;
    max-width: 200px;
    white-space: normal !important;
    word-wrap: break-word !important;
  }

  .ant-table-row .ant-table-row-expand-icon-cell {
    display: none !important;
  }

  .ant-table-row-expand-icon-cell {
    display: none;
  }

  .ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table {
    margin-block: 0;
  }

  .ant-table-tbody > tr > td {
    white-space: nowrap;
  }

  .ant-table-tbody > tr > td:last-child {
    border-right: none !important;
  }
`;


export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
`;

export const StepText = styled.span`
  font-size: 16px;
  margin-right: 20px;
`;

export const FooterButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const LeftButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const RightButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const TitleContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const BackArrow = styled(LeftOutlined)`
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  
  &:hover {
    opacity: 0.8;
  }
`;

export const InfoText = styled(Typography)`
  color: #154075;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 5px;
  margin-bottom:10px;
`;